export const MESSAGE_TYPE_NORMAL_SOUND_LEVEL = 2
export const MESSAGE_TYPE_HARD_SOUND_LEVEL = 3
